// extracted by mini-css-extract-plugin
export default {"page":"eZ","heading":"fZ","subheading":"gZ","flavorbox":"hZ","inner":"iZ","image":"jZ","label":"kZ","flavorselect":"lZ","arrow":"mZ","flavorswrap":"nZ","flavorsheader":"oZ","flavorsnav":"pZ","flavorsinner":"qZ","cancelbtn":"rZ","flavorsbottom":"sZ","retakebtn":"tZ","continueBtn":"uZ","drawerinner":"vZ","videowrap":"wZ","flavorsbottomnav":"xZ"};
    if(module.hot) {
      // 1737143664031
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  